<app-header></app-header>
<div class="tracker-detail pt0">
    <app-step-progress-bar [wizardSteps]="steps" [stepName]="activeStepName" [stepCompleted]="activeStepCompleted"></app-step-progress-bar>
    <div class="container">
        <div class="row">
            <div class="col-sm-12 w100">
                <div class="innercard">
                    <h3 class="font24 clrblue mb20 center" translate>lblConfirmedWork</h3>
                    <div class="" *ngIf="isLoadService">
                        <app-service-list [serviceList]="serviceList" [isServiceAlreadyExist]="isServiceAlreadyExist"></app-service-list>
                    </div>
                    <!-- <button class="btn btn-primary additional-btn mt-2 m-0" aria-label="Center Align" (click)="additionalInfo(mymodal);">
                        <span translate><em class="fas fa-plus mr5"></em>
                            lblAnyAdditionalInformation
                        </span>
                    </button> -->
                    <ng-container *ngIf="documentSignUrl">
                        <a [ngClass]="warrantySigned ? '' : 'warranty-btn'"  class="btn btn-primary mt-2 ml-2 m-0 position-relative document-btn" aria-label="Center Align" target="_blank" [href]="documentSignUrl">
                            <span translate><em class="fas fa-signature mr5"></em>
                                lblSignOnWarrantyDocument
                                <em *ngIf = "!warrantySigned" class="far fa-hand-point-up blinking"></em>
                            </span>
                        </a>
                        <button *ngIf = "!warrantySigned" class="btn btn-primary mt-2 ml-2 m-0 position-relative" (click)="GetWarrantyDocumentStatus()"
                        aria-label="Center Align" target="_blank">
                        <em class="fas fa-sync"></em>
                            </button>
                        <div class="right-allign-Price Warrnty-text mt-2" *ngIf = "!warrantySigned">
                                <em class="fas fa-info-circle fa-lg align-middle" style="vertical-align: middle;"></em>
                                <span translate class="ml-2 mr-2"
                                    style="font-size: small;font-style: italic;">lblWarrantyInformation</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="bottomaction">
    <div class="container">
        <div class="row">
            <ng-container *ngIf="documentSignUrl ; else elTemplate">
                <div class="col-auto ml-auto" *ngIf = "warrantySigned ; else elseTemplate">
                    <button type="submit" class="btn btn-primary btn-lg minwidth" aria-label="Center Align" (click)="moveNext()">
                        <span translate>lblNext</span>
                    </button>
                </div>
                <ng-template #elseTemplate>
                    <div class="col-auto ml-auto">
                        <button type="submit" class="btn btn-primary btn-lg minwidth" aria-label="Center Align" disabled>
                            <span translate>lblNext</span>
                        </button>
                    </div>
                  </ng-template>
            </ng-container>
            <ng-template #elTemplate>
                <div class="col-auto ml-auto">
                    <button type="submit" class="btn btn-primary btn-lg minwidth" aria-label="Center Align" (click)="moveNext()">
                        <span translate>lblNext</span>
                    </button>
                </div>
              </ng-template>
            
        </div>
        
    </div>
</div>
<ng-template #mymodal let-modal>
    <div class="modal-header black">
        <h4 class="modal-title" id="modal-basic-title" translate>lblAdditionalInformation</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12">                
                <label translate class="font16 mb-2">lblAddComment</label>
                <textarea cols="5" rows="10" #additionalDetails class="form-control hight200" [value]="serviceAdditionalDetail?.additionalDetail">{{serviceAdditionalDetail?.additionalDetail}}</textarea>
            </div>
        </div>
        <em class="mt-2 d-block" style="color: red;" translate>lblAdditionalComment</em>
    </div>
    <div class="modal-footer">
        
        <button id="Cancel" type="button" aria-label="Center Align" class="btn btn-secondary" (click)="modal.close('Save click')" translate>lblCancel</button>
        <button id="Save" type="button" aria-label="Center Align" class="btn btn-primary" (click)="saveAdditionalDetails(additionalDetails.value);" translate>lblSave</button>
    </div>
</ng-template>